import { render, staticRenderFns } from "./ProductImageUpload.vue?vue&type=template&id=02aff2f9&scoped=true"
import script from "./ProductImageUpload.vue?vue&type=script&lang=js"
export * from "./ProductImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductImageUpload.vue?vue&type=style&index=0&id=02aff2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aff2f9",
  null
  
)

export default component.exports